export default __webpack_public_path__ + "static/media/FONDO_GARBANZO.763c1a87.png";